import { VALIDATE_FIELDS} from '../action/types'
const initialState = {
    fields: new Map(),
}

export default function validationReducer(state = initialState, action) {
    switch (action.type) {
        case VALIDATE_FIELDS:
            return {
                ...state,
                fields: new Map(action.payload)
            }
        default:
            return state
    }
}